import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledEmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const StyledIcon = styled.img`
  width: 97px;
  height: 94px;
`;

export const StyledText = styled.p`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])}
`;
